import { createFileRoute, useParams } from "@tanstack/react-router";
import { CustomerGalleryPage } from "@/features/gallery-public/CustomerGalleryPage";

export const Route = createFileRoute("/gallery/share/$token")({
  component: SharedGalleryRoute,
});

function SharedGalleryRoute() {
  const { token } = useParams({ from: "/gallery/share/$token" });
  return <CustomerGalleryPage scope={{ kind: "share", token }} />;
}
